export default __webpack_public_path__ + "static/Vidrios_Aluminios_3-39791b0628372160e20cbb6eae234b4d.png";